import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error ...implicitly has an 'any' type.
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContactNotInSystemSection = ({
  setFirstName,
  setLastName,
  email
}) => {
  const handleSetFirstName = e => {
    if (e.target) {
      setFirstName(e.target.value);
    }
  };
  const handleSetLastName = e => {
    if (e.target) {
      setLastName(e.target.value);
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    marginBlockStart: "250",
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.contact-promotion-modal.emailNotFound.stepTwoLabel',
      options: {
        emailAddress: email
      }
    }), /*#__PURE__*/_jsx(FullNameInput, {
      givenNameInput: /*#__PURE__*/_jsx(FormControl, {
        required: true,
        children: /*#__PURE__*/_jsx(TextInput, {
          "data-test-id": "given-name-input",
          onChange: handleSetFirstName
        })
      }),
      familyNameInput: /*#__PURE__*/_jsx(FormControl, {
        required: true,
        children: /*#__PURE__*/_jsx(TextInput, {
          "data-test-id": "family-name-input",
          onChange: handleSetLastName
        })
      })
    })]
  });
};
ContactNotInSystemSection.displayName = 'ContactNotInSystemSection';
export default ContactNotInSystemSection;